var TooltipLooks;
(function (TooltipLooks) {
  TooltipLooks["Danger"] = 'danger';
  TooltipLooks["Default"] = 'default';
  TooltipLooks["Primary"] = 'primary';
})(TooltipLooks || (TooltipLooks = {}));
var TooltipPositions;
(function (TooltipPositions) {
  TooltipPositions["Bottom"] = 'bottom';
  TooltipPositions["Left"] = 'left';
  TooltipPositions["Right"] = 'right';
  TooltipPositions["Top"] = 'top';
})(TooltipPositions || (TooltipPositions = {}));
var TooltipTypes;
(function (TooltipTypes) {
  TooltipTypes["Description"] = 'description';
  TooltipTypes["Label"] = 'label';
})(TooltipTypes || (TooltipTypes = {}));
export { TooltipLooks, TooltipPositions, TooltipTypes };